import topology from '@highcharts/map-collection/countries/us/us-all.topo.json'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMap from 'highcharts/modules/map'
import React, { useMemo } from 'react'

HighchartsMap(Highcharts)

const STATE_NAME_TO_CODE: Record<string, string> = Object.fromEntries(
    topology.objects.default.geometries.map((geo) => [geo.properties.name, geo.properties['hc-key']])
)

const UsaStateMap = ({ data }: { data: Record<string, number> }) => {
    const options = useMemo(() => {
        const seriesData = Object.entries(data).map(([state, count]) => [STATE_NAME_TO_CODE[state], count])

        return {
            chart: {
                type: 'map',
                map: topology,
                height: 480
            },
            title: {
                text: undefined
            },
            mapNavigation: {
                enabled: false
            },
            credits: { enabled: false },
            legend: { enabled: false },
            colorAxis: {
                maxColor: '#002D72',
                minColor: '#CCD5E3',
                min: 0,
                startOnTick: false,
                endOnTick: false
            },
            series: [
                {
                    data: seriesData,
                    nullColor: '#c1c6c8',
                    borderColor: '#ffffff',
                    dataLabels: {
                        enabled: false
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            ],
            tooltip: {
                // eslint-disable-next-line string-to-lingui/missing-lingui-transformation
                headerFormat: '<div style="fill: {point.color};">●</div>'
            },
            exporting: {
                enabled: false,
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            }
        } as Highcharts.Options
    }, [data])

    return (
        <div className='w-full overflow-hidden'>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType='mapChart'
                options={options}
                containerProps={{ style: { height: '480px', width: '100%' } }}
            />
        </div>
    )
}

export default UsaStateMap
